<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="top-box">
				<div class="top-left">
					<div class="d-flex a-center" 
					style="height: 54px;padding-left: 30px;font-size: 16px;font-weight: 700;">
						添加合作伙伴
						<div @click="show=true" style="margin-left: auto;color: #1E69FF;font-size: 14px;padding-right: 30px;cursor: pointer;">+手动添加合作伙伴</div>
					</div>
					<div class="d-flex a-center"
					style="height: 28px;padding-left: 30px;font-size: 16px;font-weight: 700;">
						<el-input @input="be_agreed_partnerse" v-model="company_name" style="width: 300px;" size="small" placeholder="请输入企业名称进行搜索"></el-input>
						<el-button @click="be_agreed_partnerse" style="margin-left: 15px;background: #1E69FF;color: #FFFFFF;" size="small" >搜索</el-button>
					</div>
					<div class="hzlist">
						<div v-for="(item,index) in beAgList" :key="index"
						 style="margin-bottom: 25px;height: 60px;"
						class="d-flex a-center">
							<div style="height: 60px;width: 60px;">
								<img style="height: 60px;width: 60px;" :src="item.logo_thumb" />
							</div>
							<div style="margin-left: 15px;height: 60px;flex: 1;" class="d-flex j-sb flex-column">
								<div style="font-size: 14px;font-weight: 700;">
									{{item.company_name}}
								</div>
								<div style="font-size: 12px;color: #888;">
									{{item.kf_tel||'暂无联系信息'}}
								</div>
								<div style="font-size: 12px;color: #888;">
									{{item.business_address||'暂无地址信息'}}
								</div>
							</div>
							<div style="width: 80px;" class="d-flex a-center">
								<div @click="partnerse_apply(item)" class="d-flex a-center j-center" style="width: 80px;height: 28px;border: 2px solid #BBBBBB;
								border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
									申请
								</div>
							</div>
						</div>
						<div v-if="beAgList.length==0" class="d-flex j-center">
							<img style="width: 120px;height: 120px;margin-top: 60px;" src="../../assets/Home/zwsj@2x.png" />
						</div>
					</div>
				</div>
				<div class="top-right">
					<div class="d-flex a-center"
					style="height: 54px;padding-left: 30px;font-size: 16px;font-weight: 700;">
						邀请入驻
					</div>
					<div class="d-flex a-center"
					style="height: 28px;padding-left: 30px;font-size: 16px;font-weight: 700;">
						<el-input v-model="mobile" style="width: 300px;" size="small" placeholder="请输入被邀请人手机号码"></el-input>
						<el-button @click="send_invite_msg" style="margin-left: 15px;background: #1E69FF;color: #FFFFFF;" size="small" >发送</el-button>
					</div>
					<div class="hzlist">
						<div class="top-right-list" style="width: 100%;display: flex;justify-content: space-between;
						flex-wrap: wrap;font-size: 12px;color: #888888;">
							<div v-for="(item,index) in ivtList" :key="index" 
							style="margin-bottom: 15px;margin-right: 40px;">
								已邀请：{{item.mobile}}
							</div>
							<div v-if="ivtList.length==0" class="d-flex j-center w-100">
								<img style="width: 120px;height: 120px;margin-top: 60px;" src="../../assets/Home/zwsj@2x.png" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom-box">
				<div class="bottom-left">
					<div style="width: 40px;height: 240px;background: #DADADA;border-radius: 10px 0px 0px 10px;position: absolute;
					right: 0;top: 163px;display: flex;justify-content: space-between;flex-direction: column;">
						<div @click="topRun()" style="text-align: center;margin-top: 22px;cursor: pointer;">
							<img style="width: 24px;grid-template-columns: 24px;" src="../../assets/enterprise/zhiding@2x.png" />
							<div style="text-align: center;font-size: 12px;color: #88888;">置顶</div>
						</div>
						<div @click="setRun(1)" style="text-align: center;cursor: pointer;">
							<img style="width: 24px;grid-template-columns: 24px;" src="../../assets/enterprise/shangyi@2x.png" />
							<div style="text-align: center;font-size: 12px;color: #88888;">上移</div>
						</div>
						<div @click="setRun(2)" style="text-align: center;margin-bottom: 22px;cursor: pointer;">
							<img style="width: 24px;grid-template-columns: 24px;" src="../../assets/enterprise/xiayi@2x.png" />
							<div style="text-align: center;font-size: 12px;color: #88888;">下移</div>
						</div>
					</div>
					<div class="d-flex a-center"
					style="height: 54px;padding-left: 30px;font-size: 16px;font-weight: 700;">
						我的合作伙伴
					</div>
					<div class="hzlist" style="margin-top: 0;height: 512px;">
						<div @click="setmpIndex(item,index)"
						v-for="(item,index) in myPartnerseList" :key="index" style="height: 85px;border-bottom: 1px dashed #BBBBBB;"
						class="d-flex a-center" :style="index===mpIndex?'box-shadow: 3px 5px 5px 5px #efefef':''">
							<div style="height: 85px;"></div>
							<div style="height: 60px;width: 60px;">
								<img style="height: 60px;width: 60px;" :src="item.logo_thumb" />
							</div>
							<div style="margin-left: 15px;height: 60px;flex: 1;" class="d-flex j-sb flex-column">
								<div style="font-size: 14px;font-weight: 700;">
									{{item.company_name}}
								</div>
								<div style="font-size: 12px;color: #888;">
									{{item.kf_tel||'暂无电话信息'}}
								</div>
								<div style="font-size: 12px;color: #888;">
									{{item.business_address||'暂无地址信息'}}
								</div>
							</div>
							<div v-if="item.is_hide==1" @click="partnerse_set_hide(item,1)" style="width: 80px;font-size: 12px;color: #888;text-align: center;cursor: pointer;">
								<img style="width: 22px;height: 16px;" src="../../assets/enterprise/yincang@2x.png" />
								<div style="text-align: center;">已隐藏</div>
							</div>
							<div v-else @click="partnerse_set_hide(item,2)" style="width: 80px;font-size: 12px;color: #888;text-align: center;cursor: pointer;">
								<img style="width: 22px;height: 16px;" src="../../assets/enterprise/xianshi.png" />
								<div style="text-align: center;">已显示</div>
							</div>
						</div>
						<div v-if="myPartnerseList.length==0" class="d-flex j-center">
							<img style="width: 120px;height: 120px;margin-top: 100px;" src="../../assets/Home/zwsj@2x.png" />
						</div>
					</div>
				</div>
				<div class="bottom-right">
					<div class="d-flex a-center"
					style="height: 54px;padding-left: 30px;font-size: 16px;font-weight: 700;">
						请求列表
					</div>
					<div class="hzlist" style="margin-top: 0;height: 512px;">
						<div v-for="(item,index) in beaList" :key="index"
						 style="height: 85px;border-bottom: 1px dashed #BBBBBB;"
						class="d-flex a-center">
							<div style="height: 85px;"></div>
							<div style="height: 60px;width: 60px;">
								<img style="height: 60px;width: 60px;" :src="item.logo_thumb" />
							</div>
							<div style="margin-left: 15px;height: 60px;flex: 1;" class="d-flex j-sb flex-column">
								<div style="font-size: 14px;font-weight: 700;">
									{{item.company_name}}
								</div>
								<div style="font-size: 12px;color: #888;">
									{{item.kf_tel}}
								</div>
								<div style="font-size: 12px;color: #888;">
									{{item.business_address}}
								</div>
							</div>
							<div style="width: 80px;" class="d-flex a-center">
								<div @click="agreed_partnerse_refuse(item,1)" class="d-flex a-center j-center" style="width: 80px;height: 28px;border: 2px solid #1E69FF;
								border-radius: 4px;font-size: 12px;color: #FFFFFF;cursor: pointer;background: #1E69FF;">
									同意
								</div>
							</div>
							<div  style="width: 80px;margin-left: 15px;" class="d-flex a-center">
								<div @click="agreed_partnerse_refuse(item,2)" class="d-flex a-center j-center" style="width: 80px;height: 28px;border: 2px solid #BBBBBB;
								border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
									拒绝
								</div>
							</div>
						</div>
						<div v-if="beaList.length==0" class="d-flex j-center">
							<img style="width: 120px;height: 120px;margin-top: 100px;" src="../../assets/Home/zwsj@2x.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<el-dialog
		  title="提示"
		  :visible.sync="show"
		  width="700px"
		  top="30vh">
		  <div class="d-flex a-center">
			  <div>企业LOGO：</div>
			  <el-upload style="cursor: pointer;width: 100px;height: 100px;margin-left: 20px;"
			    :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
			    :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
			    :show-file-list="false"
			    :on-success="getLogo"
			    accept='.jpg,.png,.jpeg'>
					<img v-if="datas.logo_thumb"   style="width: 100px;height: 100px;" :src="datas.logo_thumb" />
					<img v-else style="width: 100px;height: 100px;" src="../../assets/staff/tianjiawanjian.png" />
			  </el-upload>
		  </div>
		  <div class="d-flex a-center" style="margin-top: 30px;">
			  <div>企业名称：</div>
			  <el-input maxlength="30" v-model="datas.company_name" style="width: 500px;margin-left: 20px;" placeholder="请输入企业名称"></el-input>
		  </div>
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="show=false" size="small" >取 消</el-button>
		    <el-button @click="partnerse_add()" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				beAgList:[],
				ivtList:[],
				mobile:'',
				company_name:'',
				myPartnerseList:[],
				beaList:[],
				mpIndex:'',
				mpItem:'',
				show:false,
				datas:{
					logo_thumb:'',
					company_name:''
				},
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				
			}
		},
		created() {
			this.be_agreed_partnerse()
			this.be_agreed_partnerses()
			this.invite_msg_list()
			this.my_partnerse_list()
		},
		methods: {
			partnerse_add(){
				if(this.datas.logo_thumb == ''){
					this.$message({
						showClose: true,
						message: '请上传企业logo',
						offset: 350
					})
					return
				}
				if(this.datas.company_name == ''){
					this.$message({
						showClose: true,
						message: '请输入企业名称',
						offset: 350,
					})
					return
				}
				let params = {
					act:'partnerse_add',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.datas
				}
				this.$api.be_agreed_partnerse(params).then((res)=>{
					if(res.code == 0){
						this.show = false
						this.my_partnerse_list()
						this.$message({
							showClose: true,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}
				})
			},
			getLogo(file, fileList){
				this.datas.logo_thumb = file.data
			},
			setmpIndex(item,index){
				this.mpIndex = index,
				this.mpItem = item
			},
			//置顶
			topRun(){
				if(this.mpIndex == 0){
					return
				}
				this.myPartnerseList.splice(this.mpIndex,1)
				this.myPartnerseList.splice(0,0,this.mpItem)
				this.mpIndex = ''
				this.partnerse_set_move()
			},
			//移动
			setRun(status){
				if(status == 1){
					if(this.mpIndex == 0){
						return
					}
					this.myPartnerseList.splice(this.mpIndex,1)
					this.myPartnerseList.splice(this.mpIndex-1,0,this.mpItem)
					this.mpIndex--
				}else{
					console.log(this.mpIndex);
					if(this.mpIndex == this.myPartnerseList.length-1){
						return
					}
					this.myPartnerseList.splice(this.mpIndex,1)
					this.myPartnerseList.splice(this.mpIndex+1,0,this.mpItem)
					this.mpIndex++
				}
				this.partnerse_set_move()
			},
			partnerse_set_move(){
				let ids = []
				this.myPartnerseList.forEach((item)=>{
					ids.push(item.id)
				})
				let params = {
					act:'partnerse_set_move',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids:ids.join(',')
				}
				this.$api.be_agreed_partnerse(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//申请合作伙伴列表
			be_agreed_partnerse(){
				let params = {
					act:'partnerse_search',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					company_name:this.company_name
				}
				this.$api.be_agreed_partnerse(params).then((res)=>{
					this.beAgList = []
					if(res.code == 0){
						this.beAgList = res.data
					}
				})
			},
			//短信发送记录
			invite_msg_list(){
				let params = {
					act:'invite_msg_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:99
				}
				this.$api.invite_msg_list(params).then((res)=>{
					if(res.code == 0){
						this.ivtList = res.data
					}
				})
			},
			//邀请入驻
			send_invite_msg(){
				
				if(this.mobile == ''){
					this.$message({
						showClose: false,
						message: '手机号不能为空',
						type: 'error',
						offset: 350
					})
					return; 
				}
				if(!(/^1[345678]\d{9}$/.test(this.mobile))){  
					this.$message({
						showClose: false,
						message: '请输入正确的手机号',
						type: 'error',
						offset: 350
					})
					return; 
				}
				
				let params = {
					act:'send_invite_msg',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					mobile:this.mobile
				}
				this.$api.send_invite_msg(params).then((res)=>{
					if(res.code == 0){
						this.mobile = ''
						this.invite_msg_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//申请成为合作伙伴
			partnerse_apply(item){
				let params = {
					act:'partnerse_apply',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ru_id:item.ru_id
				}
				this.$api.partnerse_apply(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '申请成功请等待对方同意',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//我的合作伙伴列表
			my_partnerse_list(){
				let params = {
					act:'my_partnerse_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:99
				}
				this.$api.my_partnerse_list(params).then((res)=>{
					this.myPartnerseList = []
					if(res.code == 0){
						this.myPartnerseList = res.data
					}
				})
			},
			be_agreed_partnerses(){
				let params = {
					act:'be_agreed_partnerse',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:99
				}
				this.$api.be_agreed_partnerse(params).then((res)=>{
					this.beaList = []
					if(res.code == 0){
						this.beaList = res.data
					}
				})
			},
			agreed_partnerse_refuse(item,index){
				let params = {
					act:index==2?'agreed_partnerse_refuse':'agreed_partnerse_agree',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.agreed_partnerse_refuse(params).then((res)=>{
					if(res.code == 0){
						this.be_agreed_partnerses()
						this.my_partnerse_list()
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			partnerse_set_hide(item,index){
				let params = {
					act:index==1?'partnerse_set_show':'partnerse_set_hide',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.agreed_partnerse_refuse(params).then((res)=>{
					if(res.code == 0){
						this.my_partnerse_list()
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}


		}
	};
</script>
<style scoped>
	.content-box{
		width: 1170px;
		min-height: 960px;
		border-radius: 6px;
		flex-wrap: wrap;
	}
	.top-box{
		height: 370px;
		display: flex;
		justify-content: space-between;
	}
	.top-left{
		width: 575px;
		height: 370px;
		background: #FFFFFF;
		border-radius: 6px;
	}
	.top-right{
		width: 575px;
		height: 370px;
		background: #FFFFFF;
		border-radius: 6px;
	}
	.bottom-box{
		margin-top: 20px;
		height: 567px;
		display: flex;
		justify-content: space-between;
	}
	.bottom-left{
		width: 575px;
		height: 567px;
		background: #FFFFFF;
		border-radius: 6px;
		position: relative;
	}
	.bottom-right{
		width: 575px;
		height: 567px;
		background: #FFFFFF;
		border-radius: 6px;
	}
	.hzlist{
		height: 263px;
		box-sizing: border-box;
		padding: 0 30px;
		margin-top: 25px;
		overflow-y: scroll;
		width: 100%;
	}
	.hzlist::-webkit-scrollbar{
		display: none;
	}
	.top-right-list::after{
		width: 167px;
		content: '';
	}
</style>
